import styled from 'styled-components';

export const StyledComponent = styled.div`
  /* reset from conflicting class */
  &.Review {
    border: none;
    padding: 0;
  }
`;

export const StyledPaymentOptionsPageContainer = styled.div<{ noMaxWidth: boolean }>`
  max-width: ${(props) => props.noMaxWidth === false && '630px'};
`;
